<div class="modal-body sticky modal-container" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="sticky-header-container">
    <div class="d-flex flex-row justify-content-between">
      <div class="modal-title">{{ modalTitle }}</div>
      <app-close-button *ngIf="!hideClose" (closeClicked)="closeClicked.emit()" />
    </div>
  </div>
  <div class="sticky-body-container">
    <ng-content></ng-content>
  </div>
  <div class="sticky-footer-container modal-footer-flex-end">
    <div class="d-flex gap-3 align-items-center">
      <ng-container *ngIf="!hideSecondary">
        <app-secondary-button
          [size]="BaseButtonSizeEnum.sm"
          [colour]="BaseButtonColourEnum.Blue"
          [disabled]="isLoading$ | async"
          *ngIf="secondaryButtonStyle === SecondaryButtonStyleEnum.Secondary"
          (buttonClicked)="secondaryClicked.emit()">
          {{ secondaryLabel }}
        </app-secondary-button>
        <app-tertiary-button
          [size]="BaseButtonSizeEnum.sm"
          [colour]="BaseButtonColourEnum.Blue"
          [disabled]="isLoading$ | async"
          *ngIf="secondaryButtonStyle === SecondaryButtonStyleEnum.Tertiary"
          [ngClass]="{ 'secondary-button': !hidePrimary }"
          (buttonClicked)="secondaryClicked.emit()">
          {{ secondaryLabel }}
        </app-tertiary-button>
      </ng-container>
      <app-primary-button
        *ngIf="!hidePrimary"
        [isLoading]="isLoading$ | async"
        [size]="BaseButtonSizeEnum.sm"
        (buttonClicked)="primaryClicked.emit()">
        {{ primaryLabel }}
      </app-primary-button>
    </div>
  </div>
</div>
